module.exports = __webpack_public_path__ + "static/media/sep.3eb11901.svg";